import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "./components/Nav";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";
import { LanguageProvider } from "./i18n/LanguageContext";
import {
  HomePage,
  ServicesPage,
  PortfolioFullPage,
  AboutFullPage,
  ContactPage,
  RecentProjectsPage,
} from "./components/MainPages";
import ExperiencesPage from "./components/ExperiencesPage";
import ConceptStorePage from "./components/ConceptStorePage";
import BookCallPage from "./components/BookCallPage";
import { ActPage, ConceptPage, EventTypePage } from "./components/DetailRoutes";
import {
  JournalPage,
  JournalPostPage,
  FaqPage,
  PressPage,
} from "./components/StandalonePages";
import ProjectDetailPage from "./components/ProjectDetailPage";
import DashboardPage from "./components/DashboardPage";
import QrPage from "./components/QrPage";
import { useParams } from "react-router-dom";

function ProjectDetailRoute() {
  const { slug } = useParams();
  return <ProjectDetailPage slug={slug} />;
}

function App() {
  // Casual media protection: block right-click / dragstart on images & videos.
  // Not tamper-proof, but stops 99% of drive-by saves.
  React.useEffect(() => {
    const block = (e) => {
      const t = e.target;
      if (t && (t.tagName === "IMG" || t.tagName === "VIDEO" || t.tagName === "PICTURE")) {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener("contextmenu", block);
    document.addEventListener("dragstart", block);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("dragstart", block);
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App" data-testid="lumiere-app">
          <Nav />
          <Routes>
          {/* 5 core pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/experiences" element={<ExperiencesPage />} />
          <Route path="/concept-store" element={<ConceptStorePage />} />
          <Route path="/portfolio" element={<ExperiencesPage />} />
          <Route path="/recent-projects" element={<RecentProjectsPage />} />
          <Route path="/projects/:slug" element={<ProjectDetailRoute />} />
          <Route path="/about" element={<AboutFullPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book-a-call" element={<BookCallPage />} />

          {/* QR + private dashboard */}
          <Route path="/qr" element={<QrPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Legacy archive */}
          <Route path="/archive" element={<PortfolioFullPage />} />

          {/* Detail sub-routes (kept from previous iteration) */}
          <Route path="/acts/:slug" element={<ActPage />} />
          <Route path="/concepts/:slug" element={<ConceptPage />} />
          <Route path="/events/:slug" element={<EventTypePage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/journal/:slug" element={<JournalPostPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/press" element={<PressPage />} />
        </Routes>
        <Footer />
        <FloatingContact />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "var(--lu-black)",
              border: "1px solid var(--lu-gold)",
              color: "var(--lu-ivory)",
              fontFamily: "'Outfit', sans-serif",
            },
          }}
        />
      </div>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
